<script lang="ts">
	//Components
	import ThermostatControl from 'src/components/XT1/Thermostat/ThermostatControl.svelte';
	import VirtualButtonControl from './Components/VirtualButtonControl.svelte';
	import TemplateCoverControl from './Templates/components/TemplateCoverControl.svelte';
	import { getVirtualTemplate } from 'src/helpers/virtual_helpers/template_helpers/virtual_template_helpers';
	//Design system
	import {
		Label,
		LabelV2,
		type DeviceButtonV2PropsTypes,
		type DoubleDeviceButtonV2PropsTypes,
		type LabelPropsTypes,
		type TripleDeviceButtonV2PropsTypes,
	} from '@Shelly/shelly-design-system/index';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import type { VirtualDeviceTemplate } from 'src/helpers/virtual_helpers/template_helpers/virtual_template_types';
	import { mapIconSolidWeightToLight } from 'src/helpers/new-layout-helpers';

	export let device: Device;
	export let statuses: VCInterfaceStatus[];
	export let labelProps: Partial<LabelPropsTypes> = {};
	export let useV2Components = false;
	export let devBtnsV2Props: {
		deviceButtonV2?: Partial<DeviceButtonV2PropsTypes>;
		doubleDeviceButtonV2?: Partial<DoubleDeviceButtonV2PropsTypes>;
		tripleDeviceButtonV2?: Partial<TripleDeviceButtonV2PropsTypes>;
	} = {
		deviceButtonV2: { size: 's' },
		doubleDeviceButtonV2: { size: 's' },
		tripleDeviceButtonV2: { size: 's' },
	};

	let template: VirtualDeviceTemplate;
	$: template = getVirtualTemplate(device);
</script>

{#if template?.type === 'cover' || template?.type === 'valve'}
	<TemplateCoverControl {device} {statuses} {useV2Components} {devBtnsV2Props} />
{:else if template?.type === 'thermostat'}
	<ThermostatControl {device} {statuses} {useV2Components} {devBtnsV2Props} />
{:else if statuses.find((i) => (i?.vcType == 'button' && i?.vcView != '') || (i?.vcType == 'boolean' && i?.vcView == 'toggle'))}
	<VirtualButtonControl
		{device}
		{statuses}
		{useV2Components}
		deviceButtonV2Props={devBtnsV2Props.deviceButtonV2}
	/>
{:else}
	{@const mainLabel = statuses.find((i) => i.mainLabel)}
	{#if mainLabel}
		{#if useV2Components}
			<LabelV2
				class="align-self-center max-width-full"
				icon={mapIconSolidWeightToLight(mainLabel.icon) || null}
				iconColor={mainLabel.iconColor || null}
				value={mainLabel.value || ''}
				type="default"
				size="l"
				{...labelProps}
			/>
		{:else}
			<Label
				class="align-self-center max-width-full"
				icon={mainLabel.icon || null}
				iconColor={mainLabel.iconColor || null}
				value={mainLabel.value || ''}
				type="default"
				size="l"
				{...labelProps}
			/>
		{/if}
	{/if}
{/if}
